export default __webpack_public_path__ + "static/media/ic_kenya.c451c238.svg";